import React from 'react';
import Box from '@mui/material/Box';

export const StagPlanner = ({  }: {  }) => {

  return (
    <>
      <Box
        sx={{
          width: '100%',
          height: '100vh'
        }}
      >
        <iframe
          src="https://partners.stagemporium.com"
          sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-modals"
          allow="cross-origin-isolated; encrypted-media"
          width="100%"
          height="100%"
          style={{border: "none"}}
        ></iframe>
      </Box>
    </>
  );
};
